//React
import { useEffect, useState } from 'react';
//API
import { HospitalApi } from '../../apis/index';
//Material-UI
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ExpandCircleDownIcon from '@mui/icons-material/ExpandCircleDown';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';
//Components
import InfinityScroll from '../../components/InfinityScroll.js';
import MyCircularProgress from '../../components/Circleprogess.js';
//lodash
import { throttle } from 'lodash';
//dayjs
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/ko';

const HospitalAdminList = (props) => {
  const [hospitals, setAccounts] = useState([]);

  const [search, setSearch] = useState(false);
  const [searchEnd, setSearchEnd] = useState(true);
  const [loading, setLoading] = useState(false);

  const [count, setCount] = useState(0);
  const [searchValue, setSearchValue] = useState('');
  const [selectValue, setSelectValue] = useState('Name');

  useEffect(() => {
    firstLoad();
  }, []);

  useEffect(() => {
    if (searchEnd) {
      if (count >= 1 && !search) {
        loadData();
      }
      if (count >= 1 && search) {
        loadsearchData();
      }
    }
  }, [count]);
  dayjs.extend(relativeTime);
  dayjs.locale('en');

  const loadDataCommon = async (isSearch, value, pageCount = 0) => {
    setLoading(false);

    let res;

    if (isSearch) {
      if (selectValue === 'Name') {
        res = await HospitalApi.getSearchHospitalNameList(value, pageCount);
      } else {
        res = await HospitalApi.getSearchHospitalEmailList(value, pageCount);
      }
    } else {
      res = await HospitalApi.getHospitalList(pageCount);
    }
    
    let transformedData = [];
    if (res.data) {
    transformedData = res.data.content.map((hospital) => ({
      data1: { key: 'ID', value: hospital.id },
      data2: { key: 'Hospital Name', value: hospital.hospitalName },
      data3: { key: 'Email', value: hospital.email },
      data4: {
        key: 'Role',
        value: hospital.memberType ? hospital.memberType.join(', ') : '',
      },
      data5: { key: 'Invitaion Status', value: hospital.memberStatus },
      data6: { key: 'Country Code', value: hospital.countryCode },
    })); } else {
      return;
    }

    setAccounts((prev) =>
      pageCount === 0 ? transformedData : [...prev, ...transformedData],
    );

    if (res.data.numberOfElements !== 15) {
      setLoading(true);
      setSearchEnd(false);
    } else {
      setLoading(false);
    }
  };

  const firstLoad = async () => {
    await loadDataCommon(false);
  };

  const loadData = async () => {
    await loadDataCommon(false, null, count);
  };

  const loadFirstsearchData = async (value) => {
    setCount(0);
    setAccounts([]);
    setSearch(true);
    const searchValueToUse = value || searchValue;
    await loadDataCommon(true, searchValueToUse, 0);
  };

  const loadsearchData = async (value) => {
    setSearch(true);
    const searchValueToUse = value || searchValue;
    await loadDataCommon(true, searchValueToUse, count);
  };

  const handleChangeValue = (e) => {
    if (e.key === 'Enter' && e.target.value.toString().length !== 0) {
      const value = e.target.value.toString().trim();
      setCount(0);
      setSearchEnd(true);
      setAccounts([]);
      setSearch(true);
      setSearchValue(value);
      loadFirstsearchData(value);
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    }
    if (e.key === 'Enter' && e.target.value.toString().length === 0) {
      setCount(0);
      setSearchEnd(true);
      setSearch(false);
      firstLoad();
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    }
  };

  const handleChangeValueClick = () => {
    if (searchValue.toString().length !== 0) {
      setCount(0);
      setSearchEnd(true);
      setAccounts([]);
      setSearch(true);
      setSearchValue(searchValue);
      loadFirstsearchData(searchValue);
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    }
    if (searchValue.toString().length === 0) {
      setCount(0);
      setSearchEnd(true);
      setSearch(false);
      firstLoad();
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    }
  };

  const hadlesearchValue = (e) => {
    setSearchValue(e.target.value);
  };

  const handleRadioChange = (event) => {
    setSelectValue(event.target.value);
  };

  const loadMoreItems = async () => {
    setCount((prevCount) => prevCount + 1);
    if (!searchEnd) {
      setLoading(false);
    }
  };

  const handleScroll = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const scrollHeight = document.documentElement.scrollHeight;
    const isAtBottom = scrollTop + windowHeight >= scrollHeight - 34;

    if (isAtBottom) {
      loadMoreItems();
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', throttle(handleScroll, 1000));
    return () =>
      window.removeEventListener('scroll', throttle(handleScroll, 1000));
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const handleRowSelection = (e) => {
    props.history.push('/updateHospitalAdmin/' + e);
  };

  return (
    <>
      <InfinityScroll
        title="HOSPITAL LIST"
        saveIcon={
          <LocalHospitalIcon
            style={{
              color: 'rgb(63, 89, 140)',
              opacity: '90%',
            }}
          />
        }
        saveLink="/saveHospitalAdmin"
        saveName="NEW HOSPITAL"
        searchPlaceholder={
          selectValue == 'Name' ? 'Enter name...' : 'Enter email...'
        }
        handleChangeValue={handleChangeValue}
        searchValue={searchValue}
        hadlesearchValue={hadlesearchValue}
        handleChangeValueClick={handleChangeValueClick}
        selectedValue={selectValue}
        onChange={handleRadioChange}
        row={hospitals}
        column={[
          { key: 'ID', value: 'ID', width: '100' },
          { key: 'Hospital Name', value: 'Hospital Name', width: '200' },
          { key: 'Email', value: 'Email', width: '250' },
          { key: 'Role', value: 'Role', width: '320' },
          {
            key: 'Invitation Status',
            value: 'Invitation Status',
            width: '150',
          },
          { key: 'Country Code', value: 'Country Code', width: '130' },
        ]}
        handleRowSelection={handleRowSelection}
        searchFlag={true}
      />

      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          marginTop: '20px',
        }}
      >
        {!loading ? <MyCircularProgress /> : <></>}
      </div>
      <div
        style={{
          position: 'fixed',
          bottom: '100px',
          right: '40px',
          width: '30px',
          height: '30px',
          backgroundColor: '#FFFFFF',
          borderRadius: '50%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <ExpandCircleDownIcon
          onClick={scrollToTop}
          style={{
            fontSize: '50px',
            color: '#3F598C',
            transform: 'rotate(180deg)',
          }}
        />
      </div>
    </>
  );
};

export default HospitalAdminList;
